export default {
	registration: 'Registration',
	register: 'Register',
	pages: {
		home: 'Main Page',
	},
	RegistrationRequired: 'Registration is required',
	LimitedAccess: 'Limited access',
	AddCal: 'Add to calendar',
	download: 'Download',
	ThankUfor: 'Thank you for registration',
	startAt: 'Broadcast starts in:',
	startOn: 'will start on',
	start: 'Start',
	at: 'at',
	linkConnect: 'Link to connect:',
	linkSend: 'The livestream link has been sent to your email',
	dontFind: 'If you do not find this email, please check your spam folder',
	consultantsContact: 'Our consultants will contact you soon',
	watchOnline: 'Watch online',
	watchVideo: 'Watch the video',
	watchNow: 'Watch Now',
	enterName: 'Please enter your name',
	logIn: 'Login',
	signInLk: 'Login',
	authentication: 'Authentication',
	signInUp: 'Sign in/sign up',
	loginSilent: 'Silent login',
	yes: 'Yes',
	no: 'No',
	typing: 'is typing...',
	message: 'Enter your message',
	name: 'Name',
	send: 'Send',
	sending: 'Sending...',
	sendAgain: 'Resend the form',
	Russia: 'Russia',
	India: 'India',
	China: 'China',
	Europe: 'Europe',
	Singapore: 'Singapore',
	Brazil: 'Brazil',
	Africa: 'Africa',
	CongressHall: 'Congress Hall',
	ChatWithAdvisor: 'Contact an advisor',
	CallBack: 'Call back',
	more: 'More',
	read: 'Read more',
	watch: 'Watch',
	listen: 'Listen',
	allMatrials: 'Read more',
	siteSearch: 'Site search',
	search: 'Search',
	example: 'For example: How do I Apply for an EMBA?',
	professors: 'Professors',
	biography: 'Biography',
	contacts: 'Contacts',
	education: 'Education',
	events: 'Events',
	programmes: 'Programmes',
	publications: 'Publications',
	research: 'Research',
	content: 'Content',
	disciplines: 'Disciplines',
	photoVideo: 'Photo, Video, Media',
	mediaContent: 'Media',
	request: 'Request a',
	requestСonsultation: 'Chat with a consultant',
	step: 'Step',
	apply: 'Apply',
	moreEvents: 'All events',
	moreNews: 'All news',
	news: 'News',
	suitableEvent: 'Can`t find a suitable event?',
	fullInfo: 'To obtain full information about the event you are interested in, please get in touch with our consultant',
	show: 'Show',
	hide: 'Hide',
	views: 'views',
	allPhoto: 'All photos',
	price: 'Price:',
	addInvoice: 'Add to invoice',
	author: 'Author',
	authors: 'Authors',
	contentSource: 'Content source',
	printCV: 'Print CV',
	addToLibrary: 'Add to library',
	delToLibrary: 'Remove from library',
	qa: 'Q&A',
	article: 'Article',
	keyPublications: 'Key publications and mention',
	offerEnds: 'Offer ends',
	giveNow: 'Donate',
	give: 'Give',
	aboutSchool: 'About School',
	hello: 'Hi',
	skolkovo_shop: 'Skolkovo Shop',
	OrganisationalStructure: 'Organisational structure',
	Management: 'Management',
	Team: 'Team',
	BoardofDirectors: 'Board of Directors',
	InternationalAdvisoryBoard: 'International Advisory Board',
	InternationalAcademicCouncil: 'International Academic Council',
	AcademicCommittee: 'Academic Committee',
	history: 'History',
	accreditations: 'Accreditations and Partnerships',
	campus: 'Campus',
	sustainability: 'Sustainability',
	codeofEthics: 'Code of Ethics',
	logoSkolkvo: '/frontimg/logo_skolkovo_eng_transparent.png',
	academicDegree: 'Academic degree:',
	readsInPrograms: 'Reads in programs:',
	schoolAdress: '100 Novaya Street, Skolkovo, Odintsovsky District, Moscow Region, 143026, Russia',
	contactConsultant: 'Contact a consultant',
	support: 'Donate now',
	share: 'Share on social media',
	shareSub: 'Share this project on',
	gratitude: 'We are grateful that you have supported the Next Step Campaign!',
	thankYouSection: 'Your name will appear in the "Thank you" section on the website',
	email: 'If for some reason you do not want this, please let us know by email:',
	authEmail: 'E-mail',
	sincerely: 'Sincerely',
	team: 'SKOLKOVO Business School team',
	campaignInformation: 'We will regularly inform you about the progress of the campaign, the amount of funds raised, and the implementation of the previously mentioned projects.',
	people: 'people',
	beenSupported: 'We have already been supported by',
	registrationOn: 'Registration for the',
	registrationClosed: 'Registration closed',
	alreadySubmitted: 'You have already submitted an application earlier. A consultant will contact you soon',
	notificationsNote: 'If you want to receive notifications about events on related topics, please, leave your details.',
	supportNote: 'Global practice shows that the development of business schools is impossible without the regular support of its alumni and partners. Donation culture is our mission to ensure sustainability and mutual support in the business community. By leaving your contact information, you give us the opportunity to thank you personally.',
	selectAll: 'Select all',
	fillNameMessage: 'Please, enter your name',
	fillLastNameMessage: 'Please, enter your last name',
	fillSecondNameMessage: 'Please, enter your second name',
	fillCompanyNameMessage: 'Please, enter your company/project',
	fillJobMessage: 'Please, fill your job',
	classPlaceholder: 'Class',
	fillClassPlaceholder: 'Please, enter your class',
	SchoolName: 'School',
	fillSchoolNameMessage: 'Please, enter your school',
	jobPlaceholder: 'Position',
	fillPhoneMessage: 'Please, enter your phone number',
	fillEmailMessage: 'Please, enter your email',
	validEmailMessage: 'Please, enter valid email',
	cityPlaceholder: 'City',
	fillCityMessage: 'Please, enter your city',
	fillUniversityMessage: 'Please, enter your university',
	universityPlaceholder: 'University',
	fillBirthdayMessage: 'Please, enter your birth date',
	birthdayPlaceholder: 'Your birth date in format dd.mm.yyyy',
	fillParticipationFormatMessage: 'Participation Format',
	fillCertificateNumberMessage: 'Certificate number',
	areYouStudent: 'Are you student or graduate?',
	commentPlaceholder: 'What question would you like to ask to speakers?',
	fillCommentMessage: 'Please, leave your comment',
	commentMaxLength: 'The comment may not be greater than 300',
	countrySelectorError: 'Choose your country',
	phoneNumberLabel: 'Enter your phone number',
	exampleEvent: 'Example:',
	agreement: 'consent to the processing of my personal data',
	agreements: 'Agreements',
	agreementsForEmail: 'Agreements for user ',
	isAgreesToMarketingEmails: 'I agree to receive information about special offers, announcements of events and programmes of SKOLKOVO and its partners',
	isAgreesToMarketingEmailsLong: 'Check the box if you would like to receive marketing emails',
	isAgreesToCanViewAlumniDirectory: 'I agree to be displayed in the School’s alumni directory',
	sendingFormIgive: 'Sending form I give',
	and: 'and',
	acceptTheTermsOfThePublicOfferAgreement: 'accept the terms of the public offer agreement',
	agreementRequired: 'You must accept the terms',
	supportEvent: 'Support',
	namePlaceholder: 'First Name',
	lastNamePlaceholder: 'Last name',
	secondNamePlaceholder: 'Second name',
	companyPlaceholder: 'Company',
	englishLevel: 'English Level',
	participationFormat: 'Participation format',
	certificateNumber: 'Certificate number',
	certificateNumberPlaceholder: 'Certificate number',
	otherSum: 'Other amount',
	totalAmount: 'Total amount',
	paymentMethod: 'Payment method',
	choosePaymentMethod: 'Choose payment method',
	choosePaymentMethodErr: 'Please, choose payment method',
	englishLevelErr: 'Please, select your level',
	bankCard: 'Debit/Credit card',
	uMoney: 'YooMoney Кошелек',
	sberbank: 'SberPay',
	tinkoff: 'Tinkoff',
	qiwi: 'Qiwi',
	cash: 'Cash',
	alfa: 'Alfa Click',
	submitAgreement: 'By submitting this Form, I hereby agree to',
	submitAgreementShort: 'By submitting the form, I',
	personalDataProcessing: 'the processing of my personal data',
	donationOffer: 'accept the terms of agreement on Public Offer for Donation',
	acceptTerms: 'accept the terms of agreement on Public Offer for',
	acceptLoyalty: 'hereby agree to join SKOLKOVO’S Loyalty Program and accept',
	acceptLoyaltyB2B: 'hereby agree to join SKOLKOVO’S Loyalty Program for Corporate clients and accept',
	agreementLoyalty: 'its Rules of Participation',
	installment: 'installment plan',
	chooseOneProgram: 'Please, choose at least one program',
	specifySum: 'Please, specify the amount',
	specifySumFromTo: 'Please, specify the amount from 500 to 600 000 Rubles',
	universityFaculty: 'Please, specify your faculty',
	openMenu: 'Open menu',
	searchVar: 'Search',
	impaired: 'Visually impaired',
	login: 'Login',
	alumni: 'Alumni',
	staff: 'Staff',
	students: 'Students',
	createAccount: 'Create an account',
	signIn: 'Sign In',
	password: 'Password',
	forgotPassword: 'Forgot your password?',
	incorrectData: 'Incorrect input data',
	loginWith: 'Login with',
	loginWithPassword: 'Login with password',
	loginWithCode: 'Login with code',
	code: 'Code',
	auth: 'Login page',
	person: 'Person',
	corporate: 'Corporate',
	createAccountPerson: 'Create a personal account',
	emailField: 'Email',
	confirmPassword: 'Confirm password',
	birthday: 'Birthday',
	agreeWith: 'I agree with',
	agreeWithLoyalty: 'By submitting the form, I agree to become a member of the School\'s Loyalty Program and accept',
	personalData: 'the storage and processing conditions of personal data',
	loyaltyLegal: 'rules of participation',
	bonusBalance: 'Bonus balance',
	priceWithFullCharge: 'Cost including loyalty points spending',
	xPointsWillBeCredited: '{points} of loyalty points will be awarded',
	xPointsWillBeCreditedAfterRegistration: '{points} points will be credited to your bonus account after registration in the School Loyalty Program',
	createAccountCorporate: 'Create a corporate account',
	adminName: 'Admin first name',
	adminLastName: 'Admin last name',
	corporateEmail: 'Corporate email for notifications',
	authDescription: 'Create an account for easy registration for events, first-line support and management of a personal loyalty program.',
	supportSchool: 'Support school',
	resetPassword: 'Password reset',
	academic: 'Academic Division',
	media: 'Media',
	historyVar: 'История',
	management: 'Governance',
	accreditationsAndPartnerships: 'Accreditations and partnerships',
	helpfulInformation: 'Good to know',
	educationalPrograms: 'Educational programmes',
	allPrograms: 'All programmes',
	eventAnnounces: 'Upcoming events',
	allEvents: 'All events',
	intellectualProperty: 'Intellectual property',
	copyright: 'SKOLKOVO. All rights reserved.',
	InformationAboutOrganization: 'Information about the educational organization',
	cancel: 'Cancel',
	pleaseSpeak: 'Please speak...',
	skolkovoShop: 'Skolkovo Shop',
	welcome: 'Welcome',
	overview: 'Overview',
	profile: 'Profile',
	activities: 'Activities',
	admissions: 'Admissions',
	myLibrary: 'Library',
	registered: 'Registrations',
	payment: 'Payment',
	purchase: 'Order history',
	activate: 'You must activate your account to access the content.',
	resend: 'Resend the letter',
	tooMAnyEmails: 'Too many emails have been sent to',
	tryAgainTime: 'Please try again in',
	activationEmail: 'Activation email has been sent again',
	logout: 'Logout',
	latestEvents: 'Notifications',
	basicDetails: 'My profile',
	fillOut: 'Please, fill out the field',
	save: 'Save',
	invalidInputData: 'Invalid input data',
	additionalDetails: 'Additional details',
	documents: 'Documents',
	settings: 'Settings',
	webinar: 'Webinar',
	workshop: 'Workshop',
	readMore: 'Read more',
	registeredFor: 'Registrations:',
	noRegistration: 'You haven\'t registered for any events',
	necessaryRegister: 'It is necessary to be registered in the system',
	toEvent: 'More',
	youOrdered: 'Orders:',
	noOrder: 'You haven\'t ordered anything yet',
	finishRegistration: 'Please complete registration and pay for the order',
	continueRegistration: 'Continue registration',
	buy: 'Pay now',
	downloadBill: 'Download invoice',
	openContract: 'Open contract',
	paidUp: 'Paid up',
	validUntil: 'Valid until',
	invoice: 'Invoice',
	billDate: 'Date of invoice',
	recommendedActivities: 'Recommended',
	detailsAndRegistration: 'Details and registration',
	moreDetails: 'More details',
	myDocuments: 'My documents',
	goToAdmission: 'More',
	dragHere: 'Drag file here',
	delete: 'Delete',
	add: 'Add',
	value: 'Value:',
	reference: 'Reference',
	fullName: 'Full name',
	enterValue: 'Enter a value',
	companyName: 'Company name',
	jobTitle: 'Job title',
	phone: 'Phone',
	addReference: 'Add reference',
	deleteReference: 'Delete reference',
	document: 'Document',
	nameOfDocument: 'Name of the document',
	fillCorrectly: 'Please fill in the field correctly',
	addDocument: 'Add document',
	deleteDocument: 'Delete document',
	educationalInstitution: 'Name of educational Institution',
	selectValue: 'Select value',
	majorField: 'Major/study field/attendance mode',
	startDate: 'Start date',
	endDate: 'End date',
	countryEdu: 'Country',
	cityEdu: 'City',
	addEdu: 'Add education',
	deleteEdu: 'Delete education',
	learnedAbout: 'How did you learn about SKOLKOVO?',
	alumniName: 'Alumni full name',
	language: 'Language',
	proficiency: 'Proficiency',
	chooseProficiency: 'Choose proficiency',
	addLanguage: 'Add language',
	deleteLanguage: 'Delete language',
	enterProgrammingLanguage: 'Enter a programming language',
	workplace: 'Workplace',
	field: 'Field',
	corporateWeb: 'Corporate website',
	lastPosition: 'Position in the company',
	from: 'From',
	to: 'To',
	keyResponsibilities: 'Key responsibilities and results',
	addWorkplace: 'Add workplace',
	deleteWorkplace: 'Delete workplace',
	jobResponsibilities: 'List the main job responsibilities (briefly). Number of characters - 500',
	otherDocs: 'Other documents',
	edit: 'Edit',
	replace: 'Replace',
	docName: 'document name',
	diploma: 'Diploma',
	noDiploma: 'I do not have a diploma',
	diplomaInfo: 'If the education was received abroad, education documents must be recognized in the Russian Federation. If your diploma is not recognized in the Russian Federation, for enrollment in the program, you will need to go through the procedure for recognizing a foreign education.',
	numberDiploma: 'Diploma number',
	scanDiploma: 'Scan of the diploma of higher education',
	addDiploma: 'Add diploma',
	deleteDiploma: 'Delete diploma',
	higherEdu: 'Do you have a higher education',
	passport: 'Passport',
	noPassport: 'I do not have a Russian passport',
	foreignPassport: 'Foreign passport',
	passportCountry: 'Issue country of the passport',
	passportNumber: 'Passport number',
	enterNumber: 'Enter passport serial number',
	noSnils: 'I don\'t have a SNILS',
	snilsNumber: 'SNILS number',
	snils: 'SNILS',
	seriesOfPassport: 'Series of passport',
	passportNumberRu: 'Passport number',
	issuingAuth: 'Issuing authority',
	issueDate: 'Passport issue date',
	issueCode: 'Issuing authority (code)',
	regAddress: 'Registration address',
	firstPage: 'First passport double page spread',
	registrationPage: 'Passport registration page',
	foreignPassportScan: 'Scan of a foreign passport',
	enterPassportSeries: 'Enter passport series',
	enterPassportNumber: 'Enter passport number',
	chooseList: 'Choose from the list',
	chooseListHint: 'You need to choose from the list of values',
	enterIssueDate: 'Enter passport issue date',
	enterIssuingAuthority: 'Enter issuing authority (code)',
	otherSettings: 'Other settings',
	emailNotifications: 'Turn on email notifications',
	yourPhoto: 'Your photo',
	chooseFile: 'Choose file',
	passwordChange: 'Password change',
	upload: 'Upload',
	camera: 'Camera',
	errorUpload: 'Uploading error, please try again',
	fileSize: 'File size must not exceed 5 MB',
	specifyIndustry: 'Specify the industry of the company you work for',
	newEconomy: 'Does the company belong to one of the industries of the new economy',
	managementBudget: 'Budget in management',
	executiveService: 'Length of executive service',
	businessAmount: 'Amount of business',
	entrepreneurialExperience: 'Entrepreneurial experience',
	subordinateEmployees: 'Number of subordinate employees',
	companyEmployees: 'Number of employees in the company',
	doesntBelong: 'No, it doesn\'t',
	admission: 'Admission',
	goBackAdmission: 'Go back to the admission',
	required: 'Required field',
	saveDraft: 'Save draft',
	underConsideration: 'Questionnaire is under consideration',
	declined: 'Questionnaire is declined',
	approved: 'Questionnaire approved',
	submitApplication: 'Submit an application for consideration',
	refuseAdmission: 'Refuse admission',
	sendQuestionnaire: 'I have completely filled in the data and am ready to send the questionnaire for consideration by the commission.',
	finalSubmit: 'You can only submit the final questionnaire once.',
	personGen: 'individuals',
	corporateEntities: 'corporate entities',
	educationPrice: 'Cost of education',
	diplomaNumber: 'Number of diploma',
	diplomaSeries: 'Diploma Series',
	DiplomaIssue: 'Diploma issue date',
	graduationDate: 'Date of graduation',
	trainingStart: 'Start date of training',
	degree: 'Degree/Diploma',
	select: 'Select',
	dateMask: 'DD.MM.YYYY',
	selectPosition: 'Select your position in the company',
	enterPosition: 'Enter your position',
	toPresent: 'To the present day',
	career: 'Career',
	newFirst: 'New ones first',
	oldFirst: 'Old ones first',
	donationsText: 'Check the box if you don\'t want your name to appear on the page',
	weThank: 'We thank',
	patronsList: 'in the list of patrons.',
	recoverHover: 'Click @:forgotPassword to send recover link on email.',
	accessRecovery: 'Access recovery',
	continue: 'Continue',
	return: 'Back',
	bio: 'bio',
	subscribeInProgress: 'Subscription in progress',
	goToCanvas: 'Canvas LMS',
	showMore: 'Show more',
	showAll: 'Show all',
	all: 'All',
	video: 'Video',
	podcast: 'Podcast',
	noContent: 'Unfortunately, no content has been found yet. You may be interested in other events and programs.',
	myProfile: 'My profile',
	skip: 'Skip',
	next: 'Next',
	back: 'Back',
	finish: 'Finish',
	loading: 'Loading',
	conditionsToGet: 'Conditions to get',
	fieldRequired: 'Required field',
	signUp: 'Sign Up',
	activationMessage: 'Activation required.',
	sendLetterTo: 'The letter was sent to ',
	received: 'Received',
	goToLK: 'Go to profile',
	b2bAlumniInput: 'I am a graduate of b2b programs',
};
